export default class SurveySingleDelivery {
    constructor(obj = {}) {
      this.surveys = obj.surveys || [];
      this.clientName = obj.clientName || null;
      this.clientEmail = obj.clientEmail || null;
    }
  }
  